import UIStrings from '@/Utils/UIStrings';

interface VerifyEmailInstructionsProps {
    email: string;
}

function VerifyEmailInstructions({ email }: VerifyEmailInstructionsProps) {
    return (
        <div className="flex flex-col gap-5 pb-10">
            <h1 className="text-foreground text-[2rem] leading-6 font-extrabold tracking-tight lg:text-[2.5rem]">
                {UIStrings.VerifyYourEmail}
            </h1>
            <p className="text-muted-foreground text-md leading-relaxed">
                <span data-testid="verify-email-instructions-1">{UIStrings.VerifyEmailInstructions1}</span>
                <span data-testid="user-email" className="text-foreground font-bold">{` ${email}. `}</span>
                <span data-testid="verify-email-instructions-2">{UIStrings.VerifyEmailInstructions2}</span>
            </p>
        </div>
    );
}

export default VerifyEmailInstructions;
